module.exports = __webpack_public_path__ + "static/media/Mitsubachi-8.cff5bc37.jpg";